module.exports = {
  "id": "ant",
  "title": "ant",
  "image": "provision/parts/ant/ant.png",
  "info": [
    {
      "text": "Add an ant to your project",
      "image": "provision/parts/ant/ant.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/ant/ant.png"
} ;